export const content = `If for any reason you and your provider don't connect, you can rematch with another provider—no questions asked. Rematching with a new provider is simple.

## Rematching with a new therapist

1. From your dashboard, look for the section about **Your Care Team**.
2. Find your current therapist then select **Find A New Therapist**.
3. Answer any questions, including adjusting any filters to refine your search.
4. Choose a therapist who better fits your needs and book your session.

## Rematching with a new psychiatric provider

1. From your dashboard, look for the section about **Your Care Team**.
2. Find your current psychiatric provider then select **Find a new psychiatrist**.
3. Answer any questions, including adjusting any filters to refine your search.
4. Choose a psychiatric provider who better fits your needs and book your session.

If you need help finding a new psychiatric provider, contact our support team.

## Viewing your previous providers

After you’ve rematched with a new provider, you can still review any of your previous providers’ information.

1. From your dashboard, go to **Your Care Team** from your navigation bar.
2. Select **Show Archived Providers** to see the names of previous providers and your last session with them.
`;
